import React from "react";
import { ListItem, ListItemText, IconButton, ListItemAvatar, Avatar } from "@material-ui/core";
import { DeleteOutline, EditOutlined } from "@material-ui/icons";
import PropTypes from "prop-types";
import EllipsisText from "react-ellipsis-text";
import { connect } from "react-redux";
const TestimonialsListItem = ({
  handleDeleteItem,
  handleEditItem,
  content,
  name,
  image,
  user: { permissions, is_super_admin },
}) => (
  <ListItem
    classes={{
      root: "text-right d-flex flex-column justify-content-start align-items-start flex-md-row align-items-md-center justify-content-md-between",
    }}
  >
    <ListItemAvatar>
      <Avatar src={image} />
    </ListItemAvatar>
    <ListItemText primary={name.ar} secondary={<EllipsisText text={content.ar} length={55} />} />
    <div className="pl-2 pr-4 d-flex align-items-center">
      {is_super_admin || permissions.includes(37) ? (
        <IconButton aria-label="edit" onClick={handleEditItem}>
          <EditOutlined />
        </IconButton>
      ) : (
        ""
      )}
      {is_super_admin || permissions.includes(38) ? (
        <IconButton aria-label="delete" onClick={handleDeleteItem}>
          <DeleteOutline color="error" />
        </IconButton>
      ) : (
        ""
      )}
    </div>
  </ListItem>
);

TestimonialsListItem.propTypes = {
  handleDeleteItem: PropTypes.func.isRequired,
  handleEditItem: PropTypes.func.isRequired,
  content: PropTypes.object.isRequired,
  name: PropTypes.object.isRequired,
  image: PropTypes.string.isRequired,
};

const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(TestimonialsListItem);
